import styled from 'styled-components';
import media from '~/client/shared/media';

const SocialBlock = styled.div`
  display: none;
  ${media.phoneMedium} {
    position: relative;
    display: block;
  }
`;

export default SocialBlock;
